import { render, staticRenderFns } from "./DeviceViewBase.vue?vue&type=template&id=ee054830&scoped=true"
import script from "./DeviceViewBase.vue?vue&type=script&lang=js"
export * from "./DeviceViewBase.vue?vue&type=script&lang=js"
import style0 from "./DeviceViewBase.vue?vue&type=style&index=0&id=ee054830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee054830",
  null
  
)

export default component.exports